import { Paper } from "@material-ui/core";
import styled from "styled-components";

export const Container = styled(Paper)`
  max-width: 700px;
  display: flex;
  flex-direction: column;
  margin: 0 auto;

  padding: 28px;

  fieldset {
    padding-top: 28px;
  }

  .MuiFormHelperText-root {
    color: red;
  }

  .customer-already-exists {
    color: #fff;

    margin: 10px;

    :hover {
      cursor: pointer;
    }

    a {
      color: #fff;
      padding-left: 10px;
    }
  }

  .react-tel-input {
    margin-bottom: 20px;
  }

  .react-tel-input .form-control {
    width: 100%;
  }

  .react-tel-input + .Mui-error {
    margin-top: -17px;
    margin-bottom: 20px;
  }

  fieldset + fieldset {
    margin-top: 20px;
  }
`;

export const Legend = styled.legend`
  color: rgba(0, 0, 0, 0.54);
  padding: 0;
  font-size: 1rem;
  font-family: "Roboto", "Helvetica", "Arial", sans-serif;
  font-weight: 400;
  line-height: 1;
  letter-spacing: 0.00938em;

  display: block;
  padding-inline-start: 2px;
  padding-inline-end: 2px;
  border-width: initial;
  border-style: none;
  border-color: initial;
  border-image: initial;
`;
